import React, {useEffect, useState} from "react";

const RowHover = ({buttons}) => {

    const [items, setItems] = useState([]);

    useEffect(() => {
        if (buttons !== undefined) {
            setItems(buttons);
        }
    }, [buttons]);

    return (
        <div
            className="hover-buttons d-flex">
            {items && items.length > 0 && items.map((item, index) => {
                return (
                    <span key={index}>
                    {item}
                </span>
                )
                    ;
            })}
        </div>
    );
};

export default RowHover;